// extracted by mini-css-extract-plugin
module.exports = {"light":"Section-module--light--JSYgb","dark":"Section-module--dark--1lqso"};